import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "domaleo_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const http = axios.create({ baseURL: API });
http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Public
export const submitContact = (data) => http.post(`/contact`, data).then((r) => r.data);
export const subscribeNewsletter = (email) => http.post(`/newsletter`, { email }).then((r) => r.data);
export const fetchContent = () => http.get(`/content`).then((r) => r.data);
export const trackView = (path, session) => axios.post(`${API}/track`, { path, session }).catch(() => {});

// Admin analytics
export const fetchAnalytics = () => http.get(`/analytics`).then((r) => r.data);

// Auth
export const login = (email, password) => http.post(`/auth/login`, { email, password }).then((r) => r.data);
export const fetchMe = () => http.get(`/auth/me`).then((r) => r.data);

// Admin content
export const updateContent = (content) => http.put(`/content`, content).then((r) => r.data);
export const resetContent = () => http.post(`/content/reset`).then((r) => r.data);

// Admin submissions
export const fetchContacts = () => http.get(`/contact`).then((r) => r.data);
export const markContactRead = (id) => http.patch(`/contact/${id}`).then((r) => r.data);
export const deleteContact = (id) => http.delete(`/contact/${id}`).then((r) => r.data);
export const fetchSubscribers = () => http.get(`/newsletter`).then((r) => r.data);
export const deleteSubscriber = (id) => http.delete(`/newsletter/${id}`).then((r) => r.data);
